import { render, staticRenderFns } from "./ComprasForm.vue?vue&type=template&id=fab4d472&"
import script from "./ComprasForm.vue?vue&type=script&lang=js&"
export * from "./ComprasForm.vue?vue&type=script&lang=js&"
import style0 from "./ComprasForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports